<pbc-sorter [config]="ObjekteSorterConfig" [sorter]="objekte.sorter$ | async" (sorterChange)="objekte.sorter$.next($event)"></pbc-sorter>
